import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { MeterRow } from './meterRows';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Home; each part uses its own slice of it */
import styles from './ArtistHome.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface HomeMeterListProps {
  /** Left out on a phone, where the switch above names the list. */
  title?: string;
  rows: MeterRow[];
}

/** One top list of the Smartlinks block: name, count and a bar (design a1). */
const HomeMeterListComponent: React.FC<HomeMeterListProps> = ({ title, rows }) => {
  const intl = useIntl();
  return (
    <div className={styles.mini}>
      {title !== undefined && <div className={styles.sectionKey}>{title}</div>}
      {rows.map((row) => (
        <div key={row.key} className={styles.miniRow}>
          <div className={styles.miniLabel}>
            {row.color !== undefined && <span className={styles.dot} style={{ background: row.color }} />}
            <span className={styles.miniName}>{row.name}</span>
            <span className={styles.miniCount}>{intl.formatNumber(row.value)}</span>
          </div>
          <div className={styles.meter}>
            <i style={{ width: `${row.widthPct}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
};

export const HomeMeterList = TypedMemo(HomeMeterListComponent);
